import { useState } from "react";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";

import ActiveSessionSlider from "./account/active-sessions/ActiveSessionSlider";
import NotificationSettingsSlider from "./account/notification/NotificationsSlider";
import PaymentMethodSlider from "./account/payment-methods/PaymentMethodSlider";
import SecuritySettingsSlider from "./account/security/SecuritySettingsSlider";
import UserProfile from "./account/user-profile/UserProfile";
import WhitelistSlider from "./account/whitelist/WhitelistSlider";

const Account = ({
  userId,
  accountType,
}: {
  userId: number;
  accountType: string;
}) => {
  const [activePanel, setActivePanel] = useState("profile");

  const getIconClass = (panel: string) =>
    `material-symbols-outlined ${
      activePanel === panel
        ? "text-[24px] text-text-navbar-active"
        : "text-[22px] text-text-base"
    }`;

  const getMenuItemClass = (panel: string) =>
    `flex justify-center ${
      activePanel === panel ? "text-text-navbar-active" : "text-text-base"
    }`;

  return (
    <div className="flex flex-row w-full min-h-full">
      <Sidebar
        collapsed={true}
        collapsedWidth="60px"
        backgroundColor={"#F8F8F8"}>
        <Menu>
          <MenuItem
            className={getMenuItemClass("profile")}
            icon={<span className={getIconClass("profile")}>person</span>}
            onClick={() => setActivePanel("profile")}
          />

          <MenuItem
            className={getMenuItemClass("payment")}
            icon={<span className={getIconClass("payment")}>credit_card</span>}
            onClick={() => setActivePanel("payment")}
          />

          <MenuItem
            className={getMenuItemClass("sessions")}
            icon={<span className={getIconClass("sessions")}>devices</span>}
            onClick={() => setActivePanel("sessions")}
          />

          <MenuItem
            className={getMenuItemClass("security")}
            icon={<span className={getIconClass("security")}>security</span>}
            onClick={() => setActivePanel("security")}
          />

          <MenuItem
            className={getMenuItemClass("notification")}
            icon={
              <span className={getIconClass("notification")}>
                notifications
              </span>
            }
            onClick={() => setActivePanel("notification")}
          />

          <MenuItem
            className={getMenuItemClass("whitelist")}
            icon={<span className={getIconClass("whitelist")}>list_alt</span>}
            onClick={() => setActivePanel("whitelist")}
          />
        </Menu>
      </Sidebar>

      {/* Right content area */}
      <div className="flex-1 min-w-0">
        {activePanel === "profile" && (
          <UserProfile
            isOpen={true}
            userId={userId}
            onClose={() => {}}
            onConfirm={() => {}}
            accountType={accountType}
          />
        )}

        {activePanel === "payment" && (
          <PaymentMethodSlider
            isOpen={true}
            userId={userId}
            onClose={() => {}}
            onConfirm={() => {}}
          />
        )}

        {activePanel === "notification" && (
          <NotificationSettingsSlider
            isOpen={true}
            userId={userId}
            accountType={accountType}
            onClose={() => {}}
            onConfirm={() => {}}
          />
        )}

        {activePanel === "whitelist" && (
          <WhitelistSlider
            isOpen={true}
            userId={userId}
            accountType={accountType}
            onClose={() => {}}
            onConfirm={() => {}}
          />
        )}

        {activePanel === "sessions" && (
          <ActiveSessionSlider
            isOpen={true}
            userId={userId}
            onClose={() => {}}
            onConfirm={() => {}}
          />
        )}

        {activePanel === "security" && (
          <SecuritySettingsSlider
            isOpen={true}
            userId={userId}
            onClose={() => {}}
            onConfirm={() => {}}
          />
        )}
      </div>
    </div>
  );
};

export default Account;
